import BatchList from 'components/Dashboard/BatchList'
import { DashboardTitle } from 'components/Dashboard/DashboardTitleContext'
import PageComponent from 'components/Dashboard/PageComponent'

const DPD: PageComponent = () => (
  <div className="container">
    <DashboardTitle title="DPD" />

    <h2 className="subtitle is-4">Recent Outbound Batches</h2>
    <BatchList batchClass="DPD" />
  </div>
)

DPD.path = '/dpd'
DPD.displayName = 'DPD'

export default DPD
